import React, {useEffect, useState} from "react";
import { Form, Button, Card, Row, Col, Collapse } from "react-bootstrap";
import DropDown from "../../../../../../DropDown/DropDown";
import ProjectAPIs from "../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useNavigate } from "react-router-dom";
import { MdAddCircle } from "react-icons/md";
import { useToast } from "../../../../../../../Contexts/ToastContext";
import UserAccountAPIs from "../../../../../../../MasonyFixingsAPIs/UserAccountAPIs/UserAccountAPIs";
import ApiResponseHandler from "../../../../../../../MasonyFixingsAPIs/ApiResponseHandler";

export default function AddInduction({projectID, handleAddNew}){

    const { addToast } = useToast();
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);
    const [addInduction, setAddInduction] = useState(false);
    const [userID, setUserID] = useState('');
    const [date, setDate] = useState('');
    const [loggedInUser, setLoggedInUser] = useState();

    const handleAdd = () => {
        if (!userID || !date) return;
        setSending(true);

        const postJSON = {
            user_id: userID,
            date: date,
        }

        if(userID !== '' && date !== ''){
            ProjectAPIs.PostProjectInduction(projectID, postJSON)
            .then((response) => {
                if(response.status ===200){
                    handleAddNew(projectID);
                    setAddInduction(false);
                    setSending(false);
                    setUserID('');
                    setDate('');
                    addToast({ message: "Induction recorded successfully!", variant: "success", autoHide: true });
                }
            })
            .catch((err) => {
                console.log(err)
                setSending(false);
                if(err.response.status === 401){
                    if(err.response.data.logout){
                        navigate('/login');
                    }
                    else{
                        window.alert(err.response.data.message)
                    }
                }
            })
        }
    };

    
    const getUserDetails = () => {
        UserAccountAPIs.GetUserAccount()
        .then((response) => {
            if(response.status === 200){
                setLoggedInUser(response.data);
                setUserID(response.data.id);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getUserDetails();
    }, []);

    return(
           
            <>
            <div className="project-header-actions">
                    <button
                        disabled={sending || !addInduction}
                        onClick={handleAdd}
                        className="save-btn"
                        style={addInduction ? {display: 'block'} : {display: 'none'}}
                    >
                        {sending ? 'Saving...' : 'Save'}
                    </button>

                        <button
                            disabled={sending}
                            className="cancel-btn"
                            onClick={() => setAddInduction(!addInduction)}
                        >
                            {addInduction ? 'Cancel' : <><MdAddCircle /> Add New</>}
                        </button>
                    
                </div>
            {/* Add Induction Form */}
            <Collapse in={addInduction} >
                <Card className="mb-2">
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                            <DropDown.Users required className='editable-field' value={userID} onChange={(e) => setUserID(e.target.value)} />
                                
                            </Col>
                            <Col md={6}>
                                <Form.Control required className='editable-field' type='date' value={date} onChange={(e) => setDate(e.target.value)} />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Collapse>
            </>
    )

}